import { ApproxTimeHead, AssessmentButton, ReviewSteps } from "ui-components";
import { useTranslation } from "react-i18next";
import "./Head.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { setSessionStorageItem } from "../../../../../utils/SessionStorageMethod/setSessionStorageItem";
import { getSessionStorageItem } from "../../../../../utils/SessionStorageMethod/getSessionStorageItem";
import { AssessmentJsonContext } from "../../../../../context/JsonContext/JsonContext";
import {
  deleteAssessmentTempData,
  getCompanyPackageDetails,
  getFrontEndSystemPreference,
  getRoleCentricRender,
} from "../../../../../service/Scope/Scope";
import { useFormikContext } from "formik";
import {
  determinePageType,
  finalDiscountCredit,
  foundUniqueId,
} from "../../../../../utils/Common/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../../../../components/CustomModal/CustomModal";
import CreditCoin from "../../../../../utils/Images/CreditCoin";
export interface HeadProps {
  handlePrevious: (count: number) => void;
  currentStep: number;
  errors?: any;
  touched?: any;
  handleNext?: ((data: any) => void) | undefined;
}
// counted credit based on question type
const countCreditForQuestion = (questionData: any, paymentDetails: any) => {
  let totalCredit = 0;
  questionData?.map((ele: any) => {
    if (ele?.questionType === "Video") {
      totalCredit =
        totalCredit +
        ele?.questionNo * paymentDetails?.creditForManualAnalysisVideoQuestion;
    } else if (ele?.questionType === "Coding") {
      totalCredit =
        totalCredit + ele?.questionNo * paymentDetails?.creditForCodingQuestion;
    } else if (ele?.questionType === "MCQ" || ele?.questionType === "Essay") {
      totalCredit =
        totalCredit + ele?.questionNo * paymentDetails?.creditForMCQ;
    } else if (ele?.type === "Single") {
      totalCredit = totalCredit + 1 * paymentDetails?.creditForCustomQuestion;
    } else if (ele?.type === "Multiple") {
      totalCredit = totalCredit + 1 * paymentDetails?.creditForCustomQuestion;
    } else if (ele?.type === "Essay") {
      totalCredit = totalCredit + 1 * paymentDetails?.creditForCustomQuestion;
    } else if (ele?.type === "Video") {
      totalCredit =
        totalCredit + 1 * paymentDetails?.creditForCustomVideoQuestion;
    }
  });
  const videoType = questionData
    ?.filter((ele: any) => ele?.questionType === "Video") // filter for "Video" question type
    .reduce((total: number, ele: any) => total + (ele?.questionNo || 0), 0);
  const evaluationAiChecks = getSessionStorageItem("evaluation");
  // transform evaluation types
  const transformedData = (evaluationAiChecks ?? []).reduce(
    (acc: any, obj: any) => {
      if (obj.type === "smartAi") {
        if (!acc.smartAi) {
          acc.smartAi = { type: "smartAi", attributes: {} };
        }
        const { ...attributes } = obj; // Extract `type` and the rest as attributes
        acc.smartAi.attributes = { ...acc.smartAi.attributes, ...attributes };
      } else if (obj.type === "manual") {
        acc.manual = obj;
      }
      return acc;
    },
    {},
  );
  const transformEvaluationResult: any = Object.values(transformedData);
  // Delete the `type` attribute from `smartAi` attributes if `smartAi` exists
  if (transformEvaluationResult[0]?.type === "smartAi") {
    delete transformEvaluationResult[0].attributes.type;
  }
  if (transformEvaluationResult[0]?.attributes?.aiAnalysis) {
    totalCredit =
      totalCredit +
      videoType * paymentDetails?.creditForAIAnalysisVideoQuestion;
  }
  if (transformEvaluationResult[0]?.attributes?.audioAnalysis) {
    totalCredit =
      totalCredit +
      videoType * paymentDetails?.creditForVoiceAnalysisVideoQuestion;
  }
  if (transformEvaluationResult[0]?.attributes?.visualAnalysis) {
    totalCredit =
      totalCredit +
      videoType * paymentDetails?.creditForVisualAnalysisVideoQuestion;
  }
  const updateTotalCredits = totalCredit === 1 ? 0 : totalCredit;
  return updateTotalCredits;
};

const Head: React.FunctionComponent<HeadProps> = ({
  handlePrevious,
  currentStep,
  handleNext = () => {},
}) => {
  const formikContext = useFormikContext();
  const { setFieldValue } = formikContext || {};
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const activeStep = determinePageType(pathname);
  // Get current language
  const currentLanguage = i18n.language;
  const contentRef = useRef<HTMLDivElement>(null);
  const renderRouteName = "template";
  const [, setTitleHeadContent] = useState(
    getSessionStorageItem("titleHeadContent"),
  );
  const [resetDraft, setResetDraft] = useState(false);
  // const [isSticky, setIsSticky] = useState(false);
  const [countQuestion, setCountQuestion] = useState<number>(
    getSessionStorageItem("totalQuestionCount"),
  );
  const isNewAssessment = localStorage.getItem("newAssessmentPopup");
  const [resetModalShow, setResetModalShow] = useState(false);
  useEffect(() => {
    // to show popup to create new assessment
    if (isNewAssessment) {
      setResetModalShow(true);
    }
    localStorage.removeItem("newAssessmentPopup");
  }, [isNewAssessment]);
  const [totalTime, setTotalTime] = useState<number>(
    getSessionStorageItem("totalQuestionTime"),
  );
  const [countedCredit, setCountedCredit] = useState(
    getSessionStorageItem("totalCountedCredit") || 0,
  );
  const [countedCreditAfterDiscount, setCountedCreditAfterDiscoun] = useState(
    getSessionStorageItem("totalCountedCreditAfterDiscount") || 0,
  );

  const { dispatch } = useContext(AssessmentJsonContext) ?? {
    state: { renderJson: {} },
    dispatch: () => {},
  };

  const reviewStepData = [
    // { stepCount: 1, stepLabel: t("GENERAL.TEMPLATE") },
    { stepCount: 1, stepLabel: t("GENERAL.BUILD") },
    { stepCount: 2, stepLabel: t("GENERAL.CUSTOM") },
    { stepCount: 3, stepLabel: t("GENERAL.SETTINGS") },
    { stepCount: 4, stepLabel: t("GENERAL.REVIEW") },
  ];
  const fetchInitialPackageDetails = async (
    renderRouteName: string,
    dispatch: any,
  ) => {
    const companyId = localStorage.getItem("companyId");
    const branchId = localStorage.getItem("branchId");
    const data: any = await getCompanyPackageDetails(companyId, branchId);
    setSessionStorageItem("paymentData", data);
    const getJsonData = await getRoleCentricRender(renderRouteName);
    dispatch({
      type: "UPDATE_CENTRIC_RENDER_JSON",
      payload: getJsonData,
    });
  };

  useEffect(() => {
    fetchInitialPackageDetails(renderRouteName, dispatch);
  }, [resetDraft]);

  const fetchData = async () => {
    try {
      const data: any = await getFrontEndSystemPreference();
      setSessionStorageItem("systemPreference", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [resetDraft]);
  // Run this effect whenever the session storage is updated
  useEffect(() => {
    // setType(getSessionStorageItem("Type") ?? "Hiring");
    setTitleHeadContent(getSessionStorageItem("titleHeadContent"));
    if (setFieldValue) {
      setFieldValue("type", getSessionStorageItem("Type") || "");
      setFieldValue(
        "titleHeadContent",
        getSessionStorageItem("titleHeadContent") || "",
      );
    }
  }, [
    getSessionStorageItem("Type"),
    getSessionStorageItem("titleHeadContent"),
  ]);

  // Your existing code...
  useEffect(() => {
    const intervalId = setInterval(() => {
      const {
        countQuestion,
        totalTime,
        totalCredit,
        totalCreditAfterDiscount,
      } = totalQuestionCount();
      setCountQuestion(countQuestion);
      setTotalTime(totalTime);
      setCountedCredit(totalCredit);
      setCountedCreditAfterDiscoun(totalCreditAfterDiscount);
    }, 100);

    return () => clearInterval(intervalId); // Clear interval on component unmount
  }, []);

  // count number of question in our assessment
  const totalQuestionCount = () => {
    const totalQuestion = (assessmentSkills: any) => {
      if (assessmentSkills[0]?.questionNo) {
        const totalQuestions = assessmentSkills.reduce(
          (accumulator: any, currentValue: any) =>
            accumulator + currentValue?.questionNo,
          0,
        );
        return totalQuestions;
      } else {
        const totalQuestions = assessmentSkills.reduce(
          (accumulator: any, currentValue: any) =>
            accumulator + currentValue?.questionsCount,
          0,
        );
        return totalQuestions;
      }
    };
    // calculate time for mcq questions
    const totalTimeForMCQ = (assessmentSkills: any) => {
      const systemPreferenceQuestionTime =
        getSessionStorageItem("systemPreference");
      let totalTime: number = 0;
      assessmentSkills?.map((item: any) => {
        if (item?.questionType === "Video") {
          totalTime =
            totalTime +
            systemPreferenceQuestionTime?.questionTime?.Video *
              item?.questionNo;
        } else if (item?.questionType === "MCQ") {
          totalTime =
            totalTime +
            systemPreferenceQuestionTime?.questionTime?.MCQ * item?.questionNo;
        } else if (item?.questionType === "Essay") {
          totalTime =
            totalTime +
            systemPreferenceQuestionTime?.questionTime?.Essay *
              item?.questionNo;
        } else if (item?.questionType === "Coding") {
          totalTime =
            totalTime +
            systemPreferenceQuestionTime?.questionTime?.Coding *
              item?.questionNo;
        }
      });
      return totalTime;
    };
    let mergeData: any = [];
    const skill = getSessionStorageItem("ownPreview") ?? [];
    const existing =
      getSessionStorageItem("existingPreview")?.subjectFieldSet ?? [];
    if (skill?.length) {
      mergeData = [...skill];
    } else {
      mergeData = [...existing];
    }
    const customQuestionSet = getSessionStorageItem("createQuestionData");
    const customQuestionTime = customQuestionSet?.reduce(
      (accumulator: any, currentValue: any) =>
        accumulator + currentValue?.timeLimit,
      0,
    );
    const countCustomQuestion =
      getSessionStorageItem("createQuestionData")?.length ?? 0;
    const countSkill = totalQuestion(mergeData) ?? 0;
    totalTimeForMCQ(mergeData);
    const countedStorageData = countCreditForQuestion(
      [...mergeData, ...(getSessionStorageItem("createQuestionData") ?? [])],
      getSessionStorageItem("paymentData")?.packageDetails ?? {},
    );
    setSessionStorageItem(
      "totalQuestionCount",
      countSkill + countCustomQuestion,
    );
    setSessionStorageItem("totalCountedCredit", countedStorageData);
    setSessionStorageItem(
      "totalCountedCreditAfterDiscount",
      finalDiscountCredit(),
    );
    const totalQuestionTimeForMCQ = totalTimeForMCQ(mergeData);
    setSessionStorageItem(
      "totalQuestionTime",
      totalQuestionTimeForMCQ +
        (isNaN(customQuestionTime) ? 0 : customQuestionTime),
    );
    return {
      countQuestion: countSkill + countCustomQuestion,
      totalTime:
        totalQuestionTimeForMCQ +
        (isNaN(customQuestionTime) ? 0 : customQuestionTime),
      totalCredit: countedStorageData,
      totalCreditAfterDiscount: finalDiscountCredit(),
    };
  };
  const handleCreateNewAssessment = async () => {
    const deleteData = await deleteAssessmentTempData(
      localStorage.getItem("companyId") ?? "",
      localStorage.getItem("tempUniqueId") ?? "",
    );
    setResetModalShow(false);
    setResetDraft(false);
    if (deleteData?.data?.status === 200) {
      sessionStorage.clear();
      localStorage.removeItem("tempUniqueId");
      localStorage.removeItem("jobId");
      fetchData();
      fetchInitialPackageDetails(renderRouteName, dispatch);
      navigate(`/${currentLanguage}/assessment/template/${foundUniqueId()}`);
    } else {
      sessionStorage.clear();
      localStorage.removeItem("tempUniqueId");
      localStorage.removeItem("jobId");
      fetchData();
      fetchInitialPackageDetails(renderRouteName, dispatch);
      navigate(`/${currentLanguage}/assessment/template/${foundUniqueId()}`);
    }
  };
  return (
    <div className="headContentSec" ref={contentRef}>
      <div className="assessmentHeading">
        <div>
          <h2>{t("CREATE_ASSESSMENT.TITLE")}</h2>
        </div>
        <div className="d-flex gap-2">
          <div className="d-flex gap-2 stickyTabs">
            {activeStep != 0 && (
              <>
                <div
                  className=""
                  title={`${t("GENERAL.TOTAL_QUESTION")} : ${
                    isNaN(countQuestion) ? 0 : countQuestion
                  }`}
                >
                  <ApproxTimeHead
                    approxTimeLabel={t("GENERAL.TOTAL_QUESTION")}
                    approxTimeValue={`${isNaN(countQuestion) ? 0 : countQuestion}`}
                  />
                </div>
                <div
                  className={` ${totalTime < 10 && "redBorder"}`}
                  title={
                    totalTime < 10
                      ? t("CREATED_ASSESSMENT.MINIMUM_10_MINS")
                      : `${t("CREATE_ASSESSMENT.DURATION")} : ${isNaN(totalTime) ? 0 : totalTime} ${t("GENERAL.MINS")}`
                  }
                >
                  <ApproxTimeHead
                    isTimerBelow={totalTime >= 10 ? false : true}
                    approxTimeLabel={t("CREATE_ASSESSMENT.DURATION")}
                    approxTimeValue={`${
                      isNaN(totalTime) ? 0 : totalTime
                    } ${t("GENERAL.MINS")}`}
                  />
                </div>
              </>
            )}
            <div
              className="timeMinWid"
              title={`${t("GENERAL.CREDITS")}${
                isNaN(countedCredit) ? 0 : countedCredit
              }`}
            >
              <ApproxTimeHead
                approxTimeLabel={<CreditCoin width={35} height={35} />}
                approxTimeValue={isNaN(countedCredit) ? 0 : countedCredit}
                isCreditCoin={true}
                discountValue={countedCreditAfterDiscount}
              />
            </div>
          </div>
          {activeStep === 0 && (
            <div>
              <AssessmentButton onClick={handleNext}>
                {countedCredit ? t("GENERAL.NEXT") : t("GENERAL.SKIP")}
              </AssessmentButton>
              <div className="buildOwn">
                <span onClick={handleNext}>
                  {t("CREATED_ASSESSMENT.BUILD_YOUR_OWN")}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      {activeStep !== 0 && (
        <div className="restLink">
          <span onClick={() => setResetDraft(true)}>
            {t("CREATE_ASSESSMENT.RESET")}
          </span>
        </div>
      )}
      {activeStep != 0 && (
        <ReviewSteps
          data={reviewStepData}
          handlePrevious={handlePrevious}
          currentStep={currentStep}
          handleNext={handleNext}
        />
      )}
      {resetDraft && (
        <CustomModal
          show={resetDraft}
          isHeaderVisible={false}
          isFooterVisible={false}
          handleClose={() => setResetDraft(false)}
          isCrossBtn={true}
          className="reset-draft-Modal"
        >
          <div className="restDraft">
            <span>
              {t("CREATED_ASSESSMENT_DO_YOU_REALLY_WANT_TO_DISCARD_CHANGES")}
            </span>
            <div className="yesNoBtn">
              <AssessmentButton
                className={"yesBtn lightBtn"}
                onClick={() => handleCreateNewAssessment()}
              >
                <span>{t("GENERAL.YES")}</span>
              </AssessmentButton>
              <AssessmentButton
                className={"NoBtn lightBtn"}
                onClick={() => setResetDraft(false)}
              >
                <span>{t("GENERAL.NO")}</span>
              </AssessmentButton>
            </div>
          </div>
        </CustomModal>
      )}
      {resetModalShow && (
        <CustomModal
          show={resetModalShow}
          isHeaderVisible={false}
          isFooterVisible={false}
          handleClose={() => setResetModalShow(false)}
          isCrossBtn={true}
          className="newAssessPopup"
        >
          <div className="newAssessPopupSec">
            <div className="confirmationText">
              <span>
                {t("CREATED_ASSESSMENT.WANT_TO_CONTINUE_OR_START_NEW")}
              </span>
            </div>
            <div className="yesNoBtn">
              <AssessmentButton
                className={"NoBtn lightBtn"}
                onClick={() => setResetModalShow(false)}
              >
                <span>{t("GENERAL.CONTINUE_EXISTING")}</span>
              </AssessmentButton>
              <AssessmentButton
                className={"yesBtn lightBtn"}
                onClick={() => handleCreateNewAssessment()}
              >
                <span>{t("GENERAL.CREATE_NEW")}</span>
              </AssessmentButton>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default Head;
